import React from 'react';
import Document from './index';
import ErrorBoundary from '../../../components/ErrorBoundary';

const Offices = React.lazy(() => import('./Offices'));
const OfficesPage = (props) => (
  <Document>
    <ErrorBoundary>
      <React.Suspense fallback={<div />}>
        <Offices {...props} />
      </React.Suspense>
    </ErrorBoundary>
  </Document>
);

export default OfficesPage;
